import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { sandboxRelayEchoPageUsingEntryPointRoute } from '@atlassian/jira-router-routes-sandbox-routes/src/sandboxRelayEchoPageUsingEntryPointRoute.tsx';
import { sandboxEchoPageEntryPoint } from '@atlassian/jira-spa-apps-sandbox-relay/src/sandboxEchoPageEntryPoint.tsx';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';

const sandboxRelayEchoPageEntryPoint = createPageEntryPoint({
	main: sandboxEchoPageEntryPoint,
	// using PROJECTS as a placeholder
	topNavigationMenuId: MENU_ID.PROJECTS,
});

export const sandboxRelayEchoPageUsingEntryPointRouteEntry = createEntry(
	sandboxRelayEchoPageUsingEntryPointRoute,
	() => ({
		group: 'sandbox',
		entryPoint: () =>
			fg('jfp-magma-support-defer') ? sandboxRelayEchoPageEntryPoint : notFoundPageEntrypoint,
		layout: globalLayout,
		resources: [],
		ufoName: 'sandbox-relay-echo',
		// eslint-disable-next-line jira/route-definitions/entry-standards
		bifrost: {
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayEchoPageUsingEntryPointRouteEntry.tsx',
				whichExportToUse: 'sandboxRelayEchoPageUsingEntryPointRouteEntry',
			},
			// WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
			// enabled: true,
			manifestName: 'jira-spa-sandboxdemo.json',
			bifrostGroup: 'not-deployed',
		},
	}),
);
